import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TransferBlockchainData } from '../../types';
import { useModalAudit } from './hooks';
import { Row } from './row';
import { useStyles } from './styles';

type ModalAuditProps = {
  transfer: TransferBlockchainData
  onClose: () => void
}

export const ModalAudit: FC<ModalAuditProps> = ({
  transfer,
  onClose
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    auditData,
    isLoading
  } = useModalAudit(transfer);

  return (
    <Dialog open onClose={onClose} maxWidth="lg">
      <DialogTitle className={classes.dialgoTitleContainer}>
        <Grid container direction="column">
          <Grid item className={classes.closeIconContainer}>
            <Button onClick={onClose} style={{ minWidth: 'auto' }}>
              <FontAwesomeIcon
                icon="plus"
                size="lg"
                transform={{ rotate: 45 }}
                className={classes.closeIcon}
              />
            </Button>
          </Grid>
          <Grid item>
            <Typography
              variant="h6"
              className={classes.dialogTitle}
            >
              {t('payments:audit')}
            </Typography>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} direction="column">
          <Grid item>
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      align="center"
                      style={{
                        backgroundColor: 'white',
                        color: '#000000',
                      }}
                    >
                      Version
                    </TableCell>
                    <TableCell
                      align="center"
                      width="800px"
                      style={{
                        backgroundColor: 'white',
                        color: '#000000',
                        border: "1px solid rgba(249, 246, 233, 1)"
                      }}
                    >
                      Block
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{
                        backgroundColor: 'white',
                        color: '#000000',
                        border: "1px solid rgba(249, 246, 233, 1)"
                      }}
                    >
                      Verified
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {isLoading && (
                    <>
                      {[...Array(10)].map(() => (
                        <TableRow>
                          {[...Array(3)].map(index => (
                            <TableCell key={index}>
                              <Skeleton />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </>
                  )}
                  {!isLoading && auditData && auditData?.history.map((history) => (
                    <Row
                      history={history}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
